import React, { useState, useEffect } from "react";
// import axios from "axios";
// Elements 
import {toast } from 'react-toastify';
import Footer from './footer';
import Header from './header';
import Contactform from './contact-form'
// import DsiteFlavors from './dsiteflavors'

// gasp
import gsap from 'gsap'
import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'
import SplitType from 'split-type'
import Slider from "react-slick";

// Images
import downarrow from '../assets/down-arrow.png'
// import glass_01 from '../assets/Glass/5.png'


// CSS
import '../product.css'

function Products() {
    
const [clients, setClients] = useState([]);


var settings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0
  
};

    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'horizontal', // vertical, horizontal
        gestureDirection: 'horizontal', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

useGSAP(() => {
     let h1 = new SplitType('.is--tight', {
              types: 'chars',
              tagName: 'span'
            });
            gsap.from(h1.chars, {
                y: '100%',
                opacity: 0,
                duration: 0.1,
                ease: 'Second.in',
                stagger: 0.1,
                
              });


              
})

let [isActive, setTabs] = useState(0)

useEffect(() => {
    fetchClients();
  }, []);

  // Fetch clients
 const fetchClients = async () => {
    try {
      const res = await fetch('https://pints.beer/api/get_clients.php');
      if (!res.ok) {
        throw new Error(`Failed to load: ${res.status} ${res.statusText}`);
      }
      const data = await res.json();
      console.log(data);
      setClients(data);
    } catch (err) {
      toast.error('Failed to fetch clients');
      setClients([]);
    }
  };
  
  
    return (
        <section className='paint-container products-container' id="smooth-wrapper">
           <Header/>
           
           <div className="section-collection-hero">
    <div className="padding-custom is--collection--hero">
        <div className="hero-bg-wrapper"><a href="#collection-1"
                className="arrow-circle-btn absolute is--collection w-inline-block"><img
                src={downarrow}
                    loading="lazy" alt={downarrow} className="arrow_img"/></a>
            <div 
                className="content-container is--collection--hero desktop">
                <h1 letters-fade-in-slow="" text-split="" className="h1 is--tight">
                100+<br/>
                Unique Beers
                </h1>
            </div>
            <div className="content-container is--collection--hero mobile">
                <h1 className="h1 is--tight">100+</h1>
                <h1 className="h1 is--tight"> Unique Beers</h1>
            </div>
        </div>
    </div>
</div>


<div className='slider-carousel'>
<Slider {...settings}>
{clients?.map((client, index) => (    
<div>
<div key={index} className={isActive === index ? 'slider-w active' : 'slider-w'} id={index} onClick={() => setTabs(index)}> 
<img className="d-block-w-100" src={`https://pints.beer/api/${client.logo}`} alt={client.logo}/>
</div>
</div>
))}
            
</Slider>
</div>



           <div className="page-wrapper">
          
    <div className="section-home-products is--products is--desktop">
    {clients?.map((client, index) => (      
        <div className="products is--desktop">
            <div className="div-block-69">
                <div className="products__flavors__text__wrapper">
                    <div className="products__flavor__text__position">
                    
                        <div id="Products"
                            className="products__flavors__text__layout">
                              
                     {isActive === index &&
                            <div className="scroll-heading-wrapper">
                                 <h2 className="section-heading">
                                 {client.name}
                                </h2>
                                <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
                        </svg> {client.location}</p>
                        <p className="p-text top-margin sticy-para">{client.description}</p>
                            </div>
                       }
                  
                        </div>
                    </div>
                </div>
             {isActive ===  index &&
              <div className="product__flavors__fixed__scroll__layout" id="collection-1">
                 {client.products.map((product) => (
              <div id="home_color-black" className="flavor__slide is--first">
                  <div className="flavor__background" id={product.beercolor}></div>
                  <div className="facts__wrapper">
                      <div className="facts__text">
                          <h3 className="h3 text-align-left black is--scroll--products">{product.name}</h3>
                          <p className="p-text top-margin">{product.description}</p>
                          <div className="service-facts">
                              <div className="service-feat is--h2 is--intro is--small is--emptybg orange">Bitterness level (IBU):	{product.bitterness}</div>
                              <div className="service-feat is--h2 is--intro is--small is--emptybg orange">Colour scale (SRM):	{product.colorscale}
                              </div>
                              <div className="service-feat is--h2 is--intro is--small is--emptybg orange">Alcoholic Strength (ABV): {product.alcoholicstrength}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
                 ))}
              </div>
             }
            
            </div>
        </div>
    ))}
    </div>
      {/* //// Mobile Site Popular list */}
    <div className="section-home-products-m is--mobile">
    {clients?.map((client, index) => (      
    <div className="product__flavors">
       
        {isActive === index &&
        <div className="scrollheading-wrapper">
            
            <h2 className="section-heading center">
            {client.name}
            </h2>
            <p className='p-text _plines map'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                    fill="currentColor" className="bi bi-geo-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411" />
                </svg> {client.location}</p>
            <p className="p-text top-margin sticy-para">
            {client.description}
            </p>
           
        </div>
        }


      {isActive === index &&
        <div className="product__flavors__fixed__scroll__layout__mobile">
              {client.products.map((product) => (
            <div id="home_color-orange" className="product__flavors__slide">
                <div className="product__flavors__slide__background watch_orange">
                    <img src={`https://pints.beer/api/glass/${product.beercolor}.png`} loading="lazy" sizes="100vw" alt="" className="product__flavors__image" />
                    <div className="facts__text">
                        <h3 className="h3 text-align-left black is--scroll--products">{product.name}</h3>
                        <p className="p-text top-margin">{product.description}</p>
                        <div className="service-facts">
                            <div className="service-feat is--h2 is--intro is--small is--emptybg green">Bitterness level
                                (IBU): {product.bitterness}</div>
                            <div className="service-feat is--h2 is--intro is--small is--emptybg green">Colour scale
                                (SRM): {product.colorscale}
                            </div>
                            <div className="service-feat is--h2 is--intro is--small is--emptybg green">Alcoholic
                                Strength (ABV): {product.alcoholicstrength}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              ))}
        </div>
}
    </div>
        ))}
</div>
</div>
       <Contactform/>
           <Footer/>
        </section>
    )}

export default Products;    